export default function SectionTitle({ eyebrow, title, kicker, align = "left" }) {
  return (
    <div className={`${align === "center" ? "text-center mx-auto max-w-3xl" : "max-w-3xl"} mb-12`}>
      {eyebrow && <div className="eyebrow mb-4">{eyebrow}</div>}
      <h2 className="serif-title text-4xl lg:text-5xl mb-4">{title}</h2>
      {kicker && <p className="text-[#4a4a4a] text-[17px] leading-relaxed">{kicker}</p>}
    </div>
  );
}
